const COMPLETED_SALE_STATUSES = new Set(["price-confirmed", "pickup-confirmed", "purchased", "sold"]);

export function isExpiredBuyerOffer(vehicle) {
  const auction = vehicle?.auction || {};
  // Only the authoritative expiry state moves a purchase. Never use the old
  // auction end/countdown while a new negotiation window may still be active.
  return auction.sellStatus === "expired"
    && vehicle?.vehicleSold !== true
    && !auction.offerAcceptedDate
    && !["pending", "completed"].includes(auction.saleConfirmationStatus)
    && vehicle?.counterOffer?.status !== "accepted";
}

export function hasConfirmedBuyerSale(vehicle) {
  const auction = vehicle?.auction || {};
  return Number(auction.finalPrice) > 0
    && Boolean(auction.offerAcceptedDate)
    && auction.saleConfirmationStatus !== "pending"
    && (vehicle?.vehicleSold === true || COMPLETED_SALE_STATUSES.has(auction.sellStatus));
}

export function buyerProcessHref(vehicle) {
  if (isExpiredBuyerOffer(vehicle)) return "/profil/gebote/nicht-gewonnen";
  const id = vehicle?.id || vehicle?.vehicleId;
  if (!id) return "/profil/gebote/im-prozess";
  return hasConfirmedBuyerSale(vehicle)
    ? `/profil/gebote/im-prozess/${encodeURIComponent(id)}/termin-vereinbaren`
    : `/marktplatz/${encodeURIComponent(id)}`;
}
